import React, { useEffect, useState } from 'react';
import { svg } from '../assets/svg/common.js';
import { convertToLocal } from '../helper/commonHelper.js'


function Event(props) {
    const [event, setEvent] = useState(null);

    useEffect(() => {
        setEvent(props.event);
    }, [props])

    return (
        <>
            <div className="row border event-section">
                <div className="col-sm-2 d-flex justify-content-center align-items-center event-date" style={{ height: '10rem' }}>
                    <svg width="75" height="75" viewBox="0 0 20 20">
                        <defs>
                            <linearGradient id="gradientText" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style={{ stopColor: '#4687ED' }} />
                                <stop offset="100%" style={{ stopColor: '#4687ED' }} />
                            </linearGradient>
                        </defs>
                        <path d="M18 3.496h-3.001v-.46a1 1 0 10-2 0v.46h-6v-.46a1 1 0 10-1.999 0v.46H2c-.633 0-1 .359-1 1v11.5c0 .641.367 1 1 1h16c.633 0 1-.359 1-1v-11.5c0-.641-.367-1-1-1z" fill="#ffffff" />
                        <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="url(#gradientText)" fontWeight='bold' fontSize="4" dy=".3em">
                            {convertToLocal(event?.[0]?.start).split(/[\s,]/)[0]}
                        </text>
                    </svg>
                    <div className='text-light'> {convertToLocal(event?.[0]?.start).split(/[\s,]/)[1]}</div>
                </div>
                <div className="col-sm">
                    <p className='my-auto font-size-15 fw-bold'>{event?.[0]?.summary.val ?? event?.[0]?.summary}</p>
                    <div className='row d-flex justify-content-center align-items-center mt-2'>
                        <div className='col-sm-1 w-auto'>
                            {svg.time_svg}
                        </div>
                        <div className='col-sm'>
                            <p className='my-auto font-size-11' style={{ color: '#979ea8' }}>When</p>
                            <p className='my-auto fw-bold font-size-13'>{convertToLocal(event?.[0]?.start)} - {convertToLocal(event?.[0]?.end)}</p>
                        </div>
                    </div>
                    {event?.[0]?.attendee.length &&
                        <div className='row d-flex justify-content-center align-items-center mt-2'>
                            <div className='col-sm-1 w-auto'>
                                {svg.people_svg}
                            </div>
                            <div className='col-sm'>
                                <p className='my-auto font-size-11' style={{ color: '#979ea8' }}>Who</p>
                                <p className='my-auto fw-bold font-size-13'>{event?.[0]?.attendee.length} guests invited</p>
                            </div>
                        </div>
                    }
                    <div className='col-sm border-top d-flex gap-1 mt-1'>
                        <span className='my-auto font-size-11' style={{ color: '#979ea8' }}>Are you going?</span>
                        <div class="btn-group btn-group-toggle border mt-1 ml-2" data-toggle="buttons">
                            <button class="btn btn-light">
                                Yes
                            </button>
                            <button class="btn btn-light" style={{ borderLeft: '#dee2e6 solid 1px' }}>
                                Maybe
                            </button>
                            <button class="btn btn-light" style={{ borderLeft: '#dee2e6 solid 1px' }}>
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Event;
